/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import styled from "styled-components"
import * as constants from "app/static/frontend/design-constants"
import { positionAdderConnection } from "selectors/position-adder-selectors"
import Icon from "app/static/frontend/components/Icon"
import classNames from "classnames"
import dateFormat from "dateformat"

import "app/static/stylus/positionAdder/positionAdder.styl"

import { WorkflowComponent, WorkflowStrip } from "quorumdesign"

export class PositionAdder extends Component {
    onClick = (item) => {
        if (this.request && this.request.abort && this.props.position.get("id")) {
            this.request.abort()
            delete this.request
        }

        if (this.props.position.get("id") || !this.request) {
            this.request = this.props.onValueChange(item.value)
        }
    }

    renderItem = (item) => (
        <div
            key={item.label}
            className={classNames({
                "position-item": true,
                active: this.props.value === item.value && !this.props.position.get("archived"),
                disabled: this.props.isLoading,
            })}
            data-cy={`position-adder-${item.label}`}
            onClick={() => !this.props.isLoading && this.onClick(item)}
            onKeyPress=""
        >
            {item.label}
            <Icon
                className="label-icon"
                name={
                    this.props.value === item.value && !this.props.position.get("archived")
                        ? "check-square-o"
                        : "square-o"
                }
            />
        </div>
    )

    renderOptionStrips = () => {
        return this.props.choices.map((item) => (
            <WorkflowStrip
                dataCy={`position-adder-${item.label}`}
                key={item.label}
                hasCheckbox
                isChecked={this.props.value === item.value && !this.props.isArchived}
                onCheckFn={() => !this.props.isLoading && this.onClick(item)}
                text={item.label}
                textType="major"
            />
        ))
    }

    render() {
        const username =
            this.props.position &&
            this.props.position.get &&
            this.props.position.get("id") &&
            this.props.position.getIn(["last_user", "username"])
        const fullName =
            this.props.position &&
            this.props.position.get &&
            this.props.position?.get("id") &&
            this.props.position.getIn(["last_user", "name"])
        const date = this.props.updatedDate && dateFormat(new Date(this.props.updatedDate), "mmm d, yyyy")

        const SubtitleWrapper = styled.span`
            color: ${constants.QuorumTheme.colors.gray[6]};
            font-style: italic;

            em {
                font-weight: ${constants.SlightlyBoldFontWeight};
            }
        `

        const archived = this.props.isArchived

        const Subtitle = () => (
            <SubtitleWrapper>
                {archived ? this.props.subtitleClearVerb || "Cleared by " : this.props.subtitleSetVerb || "Taken by "}
                <em>{!this.props.doNotShowSubtitleName && fullName}</em> on <em>{date}</em>
            </SubtitleWrapper>
        )

        // TODO improve this Render method
        return !this.props.inline ? (
            <WorkflowComponent
                emptyText={this.props.emptyText || "Loading position..."}
                title={this.props.title}
                // IF a stance has ever been set/ set then cleared, we should have a date.
                subtitle={!this.props.isLoading && Boolean(this.props.updatedDate) && <Subtitle />}
            >
                {!this.props.isLoading && this.renderOptionStrips()}
            </WorkflowComponent>
        ) : (
            <div
                className={classNames("position-adder", { "no-option-chosen": !username })}
                ref={this.props.alignmentAdderRef}
            >
                <div className="title">
                    {this.props.isLoading ? (
                        <span className="loading-position">
                            Loading<span>.</span>
                            <span>.</span>
                            <span>.</span>
                        </span>
                    ) : (
                        this.props.title
                    )}
                </div>
                <div className="choices">{this.props.choices.map(this.renderItem)}</div>
                {username &&
                    (archived ? (
                        <div className="last-user">
                            <span className="date-position-taken">
                                Position removed by <strong>{username}</strong>
                                {date ? ` on ${date}` : ""}
                            </span>
                        </div>
                    ) : (
                        <div className="last-user">
                            <span className="date-position-taken">
                                Position taken by <strong>{username}</strong>
                                {date ? ` on ${date}` : ""}
                            </span>
                        </div>
                    ))}
            </div>
        )
    }
}

PositionAdder.propTypes = {
    alignmentAdderRef: PropTypes.object,
    choices: PropTypes.array.isRequired,
    doNotShowSubtitleName: PropTypes.bool,
    emptyText: PropTypes.string,
    inline: PropTypes.bool,
    isArchived: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    onValueChange: PropTypes.func.isRequired,
    position: PropTypes.object.isRequired,
    subtitleClearVerb: PropTypes.string,
    subtitleSetVerb: PropTypes.string,
    title: PropTypes.string.isRequired,
    value: PropTypes.number,
}

export default connect(positionAdderConnection, {})(PositionAdder)
